import axios from '../axios-auth';

export const currencyExchangeRateService = {
    getCurrencyExchangeRateList,
    saveCurrencyExchangeRate,
    getLastExchangeRateByCurrencyId,
};

function getCurrencyExchangeRateList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/currency-exchange-rates", { params });
}

function saveCurrencyExchangeRate(currency) {
    return axios.post('/auth/currency-exchange-rate', currency);
}

function getLastExchangeRateByCurrencyId(id) {
    return axios.get('/auth/get-last-exchange-rate-by-currency-id/' + id);
}
